import axios from "@/utils/api-v1"

export default {
  getQuestions(tradeId) {
    return axios.get("/api/interviews/questions", { params: { tradeId } })
  },
  getInterview(interviewId) {
    return axios.get(`/api/interviews/${interviewId}`)
  },
  saveResponses(interviewId, responses) {
    return axios.patch(`/api/interviews/${interviewId}/responses`, {
      responses,
    })
  },
  submitInterview(interviewId) {
    return axios.post(`/api/interviews/${interviewId}/submit`)
  },
  adminListQuestions() {
    return axios.get("/api/admin/interview-questions")
  },
  adminCreateQuestion(data) {
    return axios.post("/api/admin/interview-questions", data)
  },
  adminUpdateQuestion(id, data) {
    return axios.patch(`/api/admin/interview-questions/${id}`, data)
  },
  adminDeleteQuestion(id) {
    return axios.delete(`/api/admin/interview-questions/${id}`)
  },
  listByProfile(profileId) {
    return axios.get(`/api/interviews/profile/${profileId}`)
  },
  adminReEvaluateInterviews() {
    return axios.post("/api/admin/interviews/re-evaluate")
  },
}
